export default __webpack_public_path__ + "ab4f5d968571b820aece73dc3fbc9476.svg";